<app-header/>
<section class="container">
  <main class="main">
    <h1 class="title">Pliki do pobrania</h1>

    <ul class="main-list">
      <li><a href="/assets/downloads/2025.05.09_Regulamin_mSpadek.pdf" target="_blank" rel="noopener noreferrer"><span class="icon-pdf" aria-hidden="true"></span>Regulamin</a></li>
      <li><a href="/assets/downloads/2025.05.09_Polityka_Prywatnosci_mSpadek.pdf" target="_blank" rel="noopener noreferrer"><span class="icon-pdf" aria-hidden="true"></span>Polityka Prywatności</a></li>
      <li><a href="/assets/downloads/2025.05.09_Informacja_o_zagrozeniach.pdf" target="_blank" rel="noopener noreferrer"><span class="icon-pdf" aria-hidden="true"></span>Informacje o zagrożeniach</a></li>
      <li><a href="/assets/downloads/2025.05.09_Informacja_o_funkcji_oprogramowania.pdf" target="_blank" rel="noopener noreferrer"><span class="icon-pdf" aria-hidden="true"></span>Informacje o funkcjach oprogramowania</a></li>
      <li><a href="/assets/downloads/2025.05.09_Informacja_wzor_odstapienia_od_umowy.pdf" target="_blank" rel="noopener noreferrer"><span class="icon-pdf" aria-hidden="true"></span>Wzór odstąpienia od umowy</a></li>
    </ul>

  </main>
</section>

<app-footer/>
